import React from 'react';

import { CurrencyFormat } from '@ha/intl';
import { useIntl } from 'ha/i18n';
import { SmartTrack as Track } from 'ha/components/track/SmartTrack';

import { Grid, Link, Typography, units } from '@hbf/dsl';

import { UtilityBills } from 'ha/models/Listing/types';
import { UtilityBillsLabelByValue } from 'ha/models/ListingUtilityBills/translations';
import { makeStyles } from 'tss-react/mui';
import { PricingStructure } from 'ha/modules/Pricing';

interface OwnProps {
  currency: string;
  price: number;
  billsType: UtilityBills;
  onBillsClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  pricingStructure?: PricingStructure;
  firstInstalment?: number;
  isCharitableAndFreeListing?: boolean;
}

const useStyles = makeStyles()(theme => ({
  price: {
    [theme.breakpoints.down('lg')]: {
      fontSize: units.rem(1.5),
    },
  },
}));

export const Price: React.FC<OwnProps> = ({
  currency,
  price,
  billsType,
  onBillsClick,
  pricingStructure,
  firstInstalment,
  isCharitableAndFreeListing = false,
}) => {
  const { T, formatCurrency } = useIntl();
  const { classes } = useStyles();
  const frequencyLabel = T('Monthly');

  const subtitle = `${frequencyLabel} (${T(
    UtilityBillsLabelByValue[billsType],
  )})`;
  return (
    <Grid container direction="column" data-test-locator="Listing/Price">
      <Grid item>
        <Grid container>
          <Grid item>
            <Typography.H2
              className={classes.price}
              component="p"
              data-test-locator="Listing/Price/Price"
              color="mint"
            >
              {isCharitableAndFreeListing
                ? T('Free')
                : formatCurrency(
                    pricingStructure === PricingStructure.instalment &&
                      firstInstalment
                      ? firstInstalment
                      : price,
                    currency,
                    currency === 'EUR'
                      ? CurrencyFormat.WITH_CURRENCY_SYMBOL_NO_FRACTION_NO_GROUPING
                      : CurrencyFormat.WITH_CURRENCY_CODE_NO_FRACTION_NO_GROUPING,
                  )}
            </Typography.H2>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        {onBillsClick ? (
          <Track name="Clicked Bills Anchor link" type="link">
            <Link
              to=""
              onClick={onBillsClick}
              data-test-locator="Listing/Price/Subtitle/Link"
            >
              <Typography.Caption
                data-test-locator="Listing/Price/Subtitle"
                color="muted"
              >
                {subtitle}
              </Typography.Caption>
            </Link>
          </Track>
        ) : (
          <Typography.Caption
            data-test-locator="Listing/Price/Subtitle"
            color="muted"
          >
            {subtitle}
          </Typography.Caption>
        )}
      </Grid>
    </Grid>
  );
};
